import React, { useMemo } from 'react';
import { categorizeEvents, mapApiRecord } from "../../../../utility/event.utils";
import EventCardView from "./event-cards.view";
import { IEventCalendarCard } from "../../type/events.types";
import dayjs, { Dayjs } from 'dayjs';
import { getMonthFromDate } from "../../utils/utils";

const EventCards: React.FC<IEventCalendarCard> = (props) => {

    const mappedData = useMemo(() => {
        const eventData = categorizeEvents(props.eventData.events || []);
        const trainingEventData = categorizeEvents(props.eventData.trainingEvents || []);
        const birthdayData = mapApiRecord(props.eventData.birthdays || []);
        const anniversaryData = mapApiRecord(props.eventData.workAnniversaries || []);

        const sortByDate = (arr: any[]) =>
            arr.sort((a, b) => dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf());

        const today = sortByDate([
            ...birthdayData.today,
            ...anniversaryData.today,
            ...eventData.today,
            ...trainingEventData.today
        ]);

        const upcoming = sortByDate([
            ...birthdayData.upcoming,
            ...anniversaryData.upcoming,
            ...eventData.upcoming,
            ...trainingEventData.upcoming
        ]);

        const passed = sortByDate([
            ...birthdayData.passed,
            ...anniversaryData.passed,
            ...eventData.passed,
            ...trainingEventData.passed
        ]);

        return {today, upcoming, passed};

    }, [
        props.eventData.workAnniversaries?.length,
        props.eventData.events?.length,
        props.eventData.birthdays?.length
    ]);

    function onMonthChange(value: Dayjs) {
        const {startDate, endDate} = getMonthFromDate(value);
        props.onRangeChange(startDate, endDate);
    }

    return (
        <EventCardView
            isAdmin={props.isAdmin}
            data={mappedData}
            handleDeleteEvent={props.handleDeleteEvent}
            openEditEventModal={props.openEditEventModal}
            activeRange={props.activeRange}
            onMonthChange={onMonthChange}
        />

    )
}

export default EventCards;
